import React, {Component} from 'react';
import reportClientError from '../util/reportClientError';

class ComponentErrorBoundary extends Component {
  constructor(props) {
    super(props);
     this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    reportClientError(error, info);
  }
  render() {
  if (this.state.hasError) {
    }

    return this.props.children;
  }
}

export default ComponentErrorBoundary;
